// import "./App.css";
// import BlogPage from "./components/Blog";
// import Navbar from "./components/Navbar";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { useEffect, useState } from "react";
// import ChatBot from "./components/Chatbot";

// // Renamed service/product files to avoid & issues
// import Products from "./pages/ServicesPage";
// import ServicesPage from "./components/services";

// import Home from "./pages/Home";
// import AboutUs from "./pages/About";
// import DataBuildServices from "./pages/DataBuildServices";
// import CustomerSupportServices from "./pages/CustomerSupportServices";
// import WebinarRegistrationServices from "./pages/WebinarRegistrationServices";
// import TelecallingServices from "./pages/TelecallingServices";
// import LeadGenerationPage from "./pages/LeadGenerationPage";
// import ContactPage from "./pages/ContactPage";
// import Careers from "./pages/Carreies";
// import ErrorPage from "./pages/Error";
// import MortgageServices from "./pages/MortgageServices";

// import Footer from "./components/Footer";

// // Loader Component
// const Loader = () => (
//   <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
//     <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
//   </div>
// );

// // Back To Top Button
// const BackToTop = () => {
//   const [visible, setVisible] = useState(false);

//   const toggleVisibility = () => {
//     if (window.scrollY > 300) setVisible(true);
//     else setVisible(false);
//   };

//   const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

//   useEffect(() => {
//     window.addEventListener("scroll", toggleVisibility);
//     return () => window.removeEventListener("scroll", toggleVisibility);
//   }, []);

//   return (
//     <button
//       onClick={scrollToTop}
//       className={`fixed bottom-6 right-6 bg-green-600 text-white p-3 rounded-full shadow-lg transition-all hover:bg-green-700 ${
//         visible ? "opacity-100" : "opacity-0 pointer-events-none"
//       }`}
//     >
//       ↑
//     </button>
//   );
// };

// function App() {
//   const [loading, setLoading] = useState(true);

//   // Simulate loader
//   useEffect(() => {
//     const timer = setTimeout(() => setLoading(false), 1000);
//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <Router>
//       {loading && <Loader />}
//       <Navbar />
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<AboutUs />} />
//         <Route path="/services-product" element={<ServicesPage />} />
//         <Route path="/dataBuildservices" element={<DataBuildServices />} />
//         <Route path="/mortgageservices" element={<MortgageServices />} />
//         <Route
//           path="/customersupportservices"
//           element={<CustomerSupportServices />}
//         />
//         <Route
//           path="/webinarregistrationservices"
//           element={<WebinarRegistrationServices />}
//         />
//         <Route path="/telecallingservices" element={<TelecallingServices />} />
//         <Route path="/leadgeneration" element={<LeadGenerationPage />} />
//         <Route path="/contact" element={<ContactPage />} />
//         <Route path="/career" element={<Careers />} />
//         <Route path="/blog" element={<BlogPage />} />
//         <Route path="/products" element={<Products />} />
//         {/* Catch-all route */}
//         <Route path="*" element={<ErrorPage />} />
//       </Routes>
//       <Footer />
//       <BackToTop />
//       <ChatBot />
//     </Router>
//   );
// }

// export default App;

import "./App.css";
import BlogPage from "./components/Blog";
import Navbar from "./components/Navbar";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useEffect, useState } from "react";
import ChatBot from "./components/Chatbot";

// Renamed service/product files to avoid & issues
import Products from "./pages/ServicesPage";
import ServicesPage from "./components/services";

import Home from "./pages/Home";
import AboutUs from "./pages/About";
import DataBuildServices from "./pages/DataBuildServices";
import CustomerSupportServices from "./pages/CustomerSupportServices";
import WebinarRegistrationServices from "./pages/WebinarRegistrationServices";
import TelecallingServices from "./pages/TelecallingServices";
import LeadGenerationPage from "./pages/LeadGenerationPage";
import ContactPage from "./pages/ContactPage";
import Careers from "./pages/Carreies";
import ErrorPage from "./pages/Error";
import MortgageServices from "./pages/MortgageServices";

import Footer from "./components/Footer";

// ✅ ScrollToTop component (new)
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Loader Component
const Loader = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
    <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

// Back To Top Button
const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 300) setVisible(true);
    else setVisible(false);
  };

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-6 right-6 bg-green-600 text-white p-3 rounded-full shadow-lg transition-all hover:bg-green-700 ${
        visible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      ↑
    </button>
  );
};

function App() {
  const [loading, setLoading] = useState(true);

  // Simulate loader
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      {loading && <Loader />}
      <ScrollToTop /> {/* 👈 Added here to reset scroll on route change */}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/services-product" element={<ServicesPage />} />
        <Route path="/dataBuildservices" element={<DataBuildServices />} />
        <Route path="/mortgageservices" element={<MortgageServices />} />
        <Route
          path="/customersupportservices"
          element={<CustomerSupportServices />}
        />
        <Route
          path="/webinarregistrationservices"
          element={<WebinarRegistrationServices />}
        />
        <Route path="/telecallingservices" element={<TelecallingServices />} />
        <Route path="/leadgeneration" element={<LeadGenerationPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/career" element={<Careers />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/products" element={<Products />} />
        {/* Catch-all route */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      <Footer />
      <BackToTop />
      <ChatBot />
    </Router>
  );
}

export default App;
